import { put, takeLatest } from "redux-saga/effects";
import { getListCampaignApi } from "store/api/SpecialOfferApi";
import { GET_LIST_CAMPAIGN_SPLASH_ACTION } from "../../actions/SpecialOfferPageAction/actionTypes";

import * as specialOfferPageAction from "../../actions/SpecialOfferPageAction";
import * as globalAction from "../../actions/GlobalAction";

function* errorMessage(message) {
	const alert = { isError: true, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* getListCampaignSplash(action) {
	const { onSuccess, business, token, infoDevice } = action?.params;
	const res = yield getListCampaignApi(business, token, infoDevice);
	try {
		if (res?.code === 0) {
			const data = res?.data;
			if (onSuccess) {
				onSuccess(data?.loyaltys);
				return;
			}
			yield put(specialOfferPageAction.setListCampaignAction(data));
		} else {
			yield errorMessage(res?.message);
		}
	} catch (e) {
		console.log(e);
	} finally {
	}
}

function* getListCampaignSplashSaga() {
	yield takeLatest(GET_LIST_CAMPAIGN_SPLASH_ACTION, getListCampaignSplash);
}

export default getListCampaignSplashSaga;
